/**
 * TrashZone Component
 * Droppable zone for hiding widgets
 */

import { useDroppable } from '@dnd-kit/core'

interface TrashZoneProps {
    isActive: boolean
}

export const TrashZone = ({ isActive }: TrashZoneProps) => {
    const { isOver, setNodeRef } = useDroppable({
        id: 'trash-zone',
    })

    return (
        <div
            ref={setNodeRef}
            className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-6 py-3 rounded-full border-2 border-dashed transition-all duration-200 ${
                isActive
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-4 pointer-events-none'
            } ${
                isOver
                    ? 'bg-red-100 border-red-500 text-red-600 scale-110'
                    : 'bg-white/90 border-gray-300 text-gray-500 backdrop-blur-sm shadow-lg'
            }`}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`w-5 h-5 transition-transform ${isOver ? 'scale-110' : ''}`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
            </svg>
            <span className="text-sm font-medium">
                {isOver ? 'Thả để ẩn' : 'Kéo vào đây để ẩn'}
            </span>
        </div>
    )
}
